import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setNotifyCustomer } from "../lib/draft.lib";

export function useSetNotifyCustomer(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));
  return (notifyCustomer: boolean) => {
    setDraft((prev) => (prev ? setNotifyCustomer(prev, notifyCustomer) : prev));
  };
}
